import { useEffect } from "react";

const useInterceptarVoltar = (componenteAlvo, setActiveComponent) => {
    useEffect(() => {
        // Adiciona uma entrada no histórico
        window.history.pushState({ manual: true }, "");

        const handlePopState = (event) => {
            // Substitui o componente quando o usuário clicar em "voltar"
            setActiveComponent(componenteAlvo);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [componenteAlvo, setActiveComponent]);
};

export default useInterceptarVoltar;
